import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import InteractiveMap from '../components/InteractiveMap';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <InteractiveMap />
      <Contact />
    </>
  );
};

export default Home;
